import React from "react";
import { Link } from "react-router-dom";
import { Grid, Menu } from "semantic-ui-react";

import TopNav from "../../common/containers/top-nav";
import StampGridContainer from "../grid/index.container";
import StampWarningContainer from "../warning/index.container";

const StampPageHome = () => {
    return (
        <Grid>
            <TopNav
                headerIcon="ticket"
                headerContent="Stamp Log"
                subheader="Your TABC stamp/invoice log"
                extraButtons={() => (
                    <Menu.Item
                        as={Link}
                        data-cy="manage_rolls"
                        icon="ticket"
                        to="/stamp/roll"
                        name="Manage Rolls"
                    />
                )}
            />

            <Grid.Column mobile={16}>
                <StampWarningContainer />
                <StampGridContainer />
            </Grid.Column>
        </Grid>
    );
};

export default StampPageHome;
